import React, { Component } from "react";
import commStyles from "../styles/styledComponents";
import ClearIcon from '@mui/icons-material/Clear';
import FLB from '../../images/FLB.jpg';


const {
  ModelBoxWrapper,
  ModelContainer,
  ModelTitleWrapper,
  MainModelContainer,
  Title,
  ModelContentWrapper,
  FormColumn,
  IconWhiteHover,
} = commStyles;

class Model extends Component {
  state = {
    modelOpen : false,
  };

  render() {
    console.log('this.props', this.props);
    // if (this.props.modelOpen){
    //   this.setState({modelOpen : true})
    // } else {
    //   this.setState({modelOpen : false})
    // }
    return (
      <React.Fragment>
        <MainModelContainer
          style={
            this.props.modelOpen
              ? { display: "flex" }
              : { display: "none" }
          }
        >
          <ModelContainer style={{maxWidth : this.props.maxWidth}}>
            <ModelBoxWrapper style={{maxWidth : this.props.maxWidth}} >
              <ModelTitleWrapper>
                <Title>{this.props.title}</Title>
                <IconWhiteHover
                  style={{color : "#FFF"}}
                  onClick={()=>{this.props.closeModel(this.props.closeModelKey)}}
                >
                  <ClearIcon/>
                </IconWhiteHover>
              </ModelTitleWrapper>
              <ModelContentWrapper
              >
                <FormColumn
                >
                  {this.props.children}
                </FormColumn>
              </ModelContentWrapper>
            </ModelBoxWrapper>
          </ModelContainer>
        </MainModelContainer>
      </React.Fragment>
    );
  }
}

export default Model;
